export const SET_SHOW_MODAL = 'userManagement/SET_SHOW_MODAL';
export const SET_SUCCESS = 'userManagement/SET_SUCCESS';

export const BULK_UPDATE_USER_REQUEST = 'userManagement/BULK_UPDATE_USER_REQUEST';
export const BULK_UPDATE_USER_SUCCESS = 'userManagement/BULK_UPDATE_USER_SUCCESS';
export const BULK_UPDATE_USER_FAILURE = 'userManagement/BULK_UPDATE_USER_FAILURE';
